import { Routes } from '@angular/router';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { LocationComponent } from './location.component';
import { CreateLocationComponent } from './create-location/create-location.component';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { ViewLocationComponent } from './view-location/view-location.component';
import { LocationImportComponent } from './location-import.component';
import { LocationMergeComponent } from './location-merge.component';

export const locationRoutes: Routes = [
    {
        path: 'location/merge-duplicates', component: LocationMergeComponent,
        canActivate: [PermissionGuard], data: { permission: app_permissions.location.records.edit }
    },
    {
        path: 'location',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: { enterpriseModules: ['SHIPMENTS', 'FLEET'], enterpriseFeatureLabel: 'Operations' },
        children: [
            {
                path: '',
                component: LocationComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.location.records.view },
            },
            {
                path: 'import',
                component: LocationImportComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.location.records.view },
            },
            {
                path: 'create',
                component: CreateLocationComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.location.records.create },
            },
            {
                path: 'edit/:id',
                component: CreateLocationComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.location.records.edit },
            },
            {
                path: 'view/:id',
                component: ViewLocationComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.location.records.view },
            },
        ],
    },
];
